import { render, staticRenderFns } from "./TravelInfoEdit.vue?vue&type=template&id=5f72ef45&scoped=true&"
import script from "./TravelInfoEdit.vue?vue&type=script&lang=js&"
export * from "./TravelInfoEdit.vue?vue&type=script&lang=js&"
import style0 from "./TravelInfoEdit.vue?vue&type=style&index=0&id=5f72ef45&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5f72ef45",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VApp } from 'vuetify/lib/components/VApp';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VSpacer } from 'vuetify/lib/components/VGrid';
import { VSwitch } from 'vuetify/lib/components/VSwitch';
installComponents(component, {VApp,VCol,VRow,VSpacer,VSwitch})
